<template>
    <section>
        <div class="section-header">
            <!-- <h2>Semua Artikel</h2> -->
        </div>
        <div class="section-body">
            <template v-if="articles">
                <FilteredPromosComponent v-if="filteredPromos"/>
                <template v-else>
                    <template v-if="!searchbarCategory.input.value">
                        <div class="sb-inner" v-if="articles">
                            <div class="sb-card" v-for="article in articles" :key="article">
                                <router-link :to="'/promo/detail/promo-medical-check-up'">
                                    <div class="sbc-content">
                                        <div class="sbc-image">
                                            <img src="../../assets/images/pictures/promo.png" alt="melinda hospital" v-if="article.thumb_small">
                                        </div>
                                        <div class="sbc-detail">
                                            <h3>{{ article.name }}</h3>
                                            <div class="sd-specialist">
                                                <span>{{ article.category?.name }}</span>
                                            </div>
                                            <!-- <div class="nlabel">
                                                <span>{{ article.category.name ? article.category.name : '' }}</span>
                                            </div> -->
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                        <div class="page-more">
                            <div class="next-loading" v-if="nextLoading">
                                <div class="loader-next"></div>
                            </div>
                            <div class="page-next" v-if="metaPage?.to < metaPage?.total">
                                <span @click="nextPage">Selanjutnya...</span>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="search-not-found">
                            <p>Tidak ditemukan artikel dengan kata kunci :</p>
                            <div v-if="searchbarCategory.input.value">"{{ searchbarCategory.input.value }}"</div>
                            <div v-if="searchbarSelectCategory.input.value.length > 0">"{{ searchbarSelectCategory.input.value }}"</div>
                            <div v-if="searchbarCategory.select.value != 'all'">dalam {{ searchbarCategory.select.title }}</div>
                            <div v-else>dalam semua kategori</div>
                        </div>
                    </template>
                </template>
            </template>
            <FilteredPromosSkeleton v-else />
        </div>
    </section>
</template>
<script setup>
    import { computed } from "@vue/runtime-core";
    import { usePromoStore } from "../../stores/promo";
    import FilteredPromosSkeleton from "../skeletons/FilteredPromosSkeleton.vue";
    import FilteredPromosComponent from "@/components/promos/FilteredPromosComponent.vue";
    import { nextPage } from "@/functions/promo";
    const articles = computed(() => usePromoStore().filteredPromos);
    const filteredPromos = computed(() => usePromoStore().filteredPromos);
    const searchbarSelectCategory = computed(() => usePromoStore().searchbarSelectCategory);
    const searchbarCategory = computed(() => usePromoStore().searchbarCategory);
    const metaPage = computed(() => usePromoStore().metaPage);
    const nextLoading = computed(() => usePromoStore().nextLoading);
    usePromoStore().setArticles();
</script>
<style scoped src="../../assets/css/promos/promo-list.css">
    /* @import url('../../assets/css/promos/promo-list.css'); */
    section{
        padding-left: 9%;
        padding-right: 9%;
        padding-bottom: 2.5rem;
        width: 100%;
        transition: 0.2s;
    }
    .section-header{
        padding: 1%;
        padding-top: 0;
    }
    .section-header h2{
        font-family: poppins;
        color: var(--white);
        margin: 0;
    }
    @media only screen and (max-width: 1500px){
        section{
            padding-left: 4%;
            padding-right: 4%;
        }
    }
    @media only screen and (max-width: 750px){
        section{
            padding-left: 1%;
            padding-right: 1%;
        }
        .section-header h2{
            color: var(--grey);
        }
    }
</style>